<div #sidebar class="col-12 col-md-3 col-xl-2 bd-sidebar" (mouseenter)="sideBarMouseEnter()"
    (mouseleave)="sideBarMouseLeave()">
    <nav class="bd-links">
        <ul id="launcher" class="nav bd-sidenav">
            <li>
                <a (click)="optionSelected($event, 'FBI Clientes', appSelector.appGroup.FBIClients)">
                    <span class="icon ico-clients"></span>
                    <span class="bd-sidenav-title">FBI Clientes</span>
                </a>
            </li>
            <li>
                <a (click)="optionSelected($event, 'FBI Talento', appSelector.appGroup.FBITalent)">
                    <span class="icon ico-talent"></span>
                    <span class="bd-sidenav-title">FBI Talento</span>
                </a>
            </li>
            @if (groupApps[appSelector.appGroup.FBIReports] > 0) {
              <li>
                <a (click)="optionReportSelected($event, 'FBI Informes', appSelector.appGroup.FBIReports)">
                    <span class="icon ico-reports"></span>
                    <span class="bd-sidenav-title">FBI Informes</span>
                </a>
              </li>
            }

            @if (groupApps[appSelector.appGroup.FBIDocumentation] > 0) {
              <li>
                <a (click)="optionSelected($event, 'FBI Documentación', appSelector.appGroup.FBIDocumentation)">
                    <span class="icon ico-platforms"></span>
                    <span class="bd-sidenav-title">FBI Documentación</span>
                </a>
              </li>
            }

            @if (groupApps[appSelector.appGroup.Administration] > 0) {
              <li>
                <a (click)="optionSelected($event, 'Administrativo', appSelector.appGroup.Administration)">
                    <span class="icon ico-admin"></span>
                    <span class="bd-sidenav-title">Administrativo</span>
                </a>
              </li>
            }
        </ul>
    </nav>
</div>
<app-selection-dialog #appSelector></app-selection-dialog>
<app-powerbi-dialog></app-powerbi-dialog>
